type ErrorWithMessage = Error & {message: string};

const isErrorWithMessage = (error: unknown): error is ErrorWithMessage => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as Record<string, unknown>).message === 'string'
  );
};

const toErrorWithMessage = (maybeError: unknown): ErrorWithMessage => {
  if (isErrorWithMessage(maybeError)) {
    return maybeError;
  }
  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    return new Error(String(maybeError));
  }
};

const getErrorMessage = (error: unknown) => {
  return toErrorWithMessage(error).message;
};

const wrapError = (maybeError: Error|unknown, message?: string) => {
  let wrappedError: Error;
  if (!(maybeError instanceof Error)) {
    wrappedError = toErrorWithMessage(maybeError);
  } else {
    wrappedError = maybeError;
  }

  wrappedError.message = message ?
    `${message}: ${getErrorMessage(maybeError)}` :
    `${getErrorMessage(maybeError)}`;

  return wrappedError;
};

export {
  wrapError,
};
